export default __webpack_public_path__ + "static/media/bbag.c0d042d3.png";